import { loadingFadeOut } from 'virtual:app-loading'
import { createStartupCoordinator } from './startupCoordinator'

let loadingFadeStarted = false
let startupLoadingRetained = false

export function retainStartupLoading() {
  startupLoadingRetained = true
}

export function releaseStartupLoading() {
  startupLoadingRetained = false
  document.querySelector<HTMLElement>('[data-app-loading]')?.remove()
}

export function beginStartupLoadingFade() {
  if (loadingFadeStarted) {
    return
  }
  loadingFadeStarted = true

  const loadingRoot = document.querySelector<HTMLElement>('[data-app-loading]')
  if (loadingRoot?.dataset.initialRoute === 'non-home') {
    loadingRoot.remove()
    return
  }
  if (startupLoadingRetained) {
    loadingRoot?.style.setProperty('pointer-events', 'none')
    return
  }
  loadingFadeOut()
}

const startupCoordinator = createStartupCoordinator(beginStartupLoadingFade)

export const markStartupRouterReady = startupCoordinator.markRouterReady
export const registerHomeStartupHandoff = startupCoordinator.registerHomeHandoff
